import { render, staticRenderFns } from "./Evaluate.vue?vue&type=template&id=cb5b90aa&scoped=true&"
import script from "./Evaluate.vue?vue&type=script&lang=js&"
export * from "./Evaluate.vue?vue&type=script&lang=js&"
import style0 from "./Evaluate.vue?vue&type=style&index=0&id=cb5b90aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5b90aa",
  null
  
)

export default component.exports